<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      {
        expanded: !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered),
      },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light',
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div style="height: 2cm" class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">
          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link class="navbar-brand" to="/">
              <span class="brand-logo">
                <li class="nav-item mr-auto">
                  <b-link class="navbar-brand" to="/">
                    <span class="brand-logo">
                      <b-img
                        :src="logo"
                        style="width: 40px; height: 40px; margin-top: 15px"
                        alt="logo"
                      />
                    </span>
                    <h2 class="brand-text">
                      <b-img
                        :src="logotxt"
                        style="width: 115px; height: 32px; margin-top: 15px"
                        alt="logo"
                      />
                    </h2>
                  </b-link>
                </li>
              </span>
            </b-link>
          </li>

          <!-- Toggler Button -->
          <li class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon
                icon="XIcon"
                size="20"
                class="d-block d-xl-none"
                @click="toggleVerticalMenuActive"
              />
              <feather-icon
                :icon="collapseTogglerIconFeather"
                size="20"
                class="d-none d-xl-block collapse-toggle-icon"
                @click="toggleCollapsed"
              />
            </b-link>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div :class="{ 'd-block': shallShadowBottom }" class="shadow-bottom" />
    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="
        (evt) => {
          shallShadowBottom = evt.srcElement.scrollTop > 0;
        }
      "
    >
      <vertical-nav-menu-items
        :items="navMenuItems"
        :dashboard="dashboard"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>
// import navMenuItems from "@/navigation/vertical";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { BLink, BImg } from "bootstrap-vue";
import { provide, computed, ref } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";
import { $themeConfig } from "@themeConfig";
import VerticalNavMenuItems from "./components/vertical-nav-menu-items/VerticalNavMenuItems.vue";
import useVerticalNavMenu from "./useVerticalNavMenu";
import dashboardData from "../../../../../../src/navigation/vertical/dashboard";
import logo from "../../../../../../public/logo.png";
import logotxt from "../../../../../../src/assets/images/logo/ngerplogotxt.png";

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
  },
  data() {
    return {
      navMenuItems: [],
      logo,
      logotxt,
      IsKyc: "",
      userData: {},
      dashboard: [],
      isDashboardInApi: false,
    };
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  mounted() {
    const accessToken = localStorage.getItem("accessToken"); // JSON.parse()
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    };
    const baseApi = process.env.VUE_APP_APIENDPOINT;

    fetch(`${baseApi}/getSidebardata`, requestOptions)
      .then((res) => res.json())
      .then((json) => {
        this.navMenuItems = [];
        this.dashboard = [];
        let arr = [];
        Object.keys(json.data).forEach((key) => {
          arr = [...arr, { ...json.data[key] }];
        });
        localStorage.removeItem("sidebarData");
        let newArr = {};
        localStorage.setItem("sidebarData", JSON.stringify(arr));
        this.navMenuItems = arr;
        


        // Helper function to recursively process children
        const setChildren = (children) => {
          if (!children || !Array.isArray(children) || children.length === 0) {
            return;
          }
          children.forEach((child) => {
            if (child.children && Array.isArray(child.children) && child.children.length > 0) {
              newArr[child.route] = {
                route: child.route,
                name: child.name,
                icon: child.icon,
                title: child.title
              };
              setChildren(child.children);
            }else{
              if (child.route === 'dashboard-analytics') {
                this.isDashboardInApi = true;
              }
            newArr[child.route] = child;
            }
          });
        };

        

        // Process all menu items and their children
        this.navMenuItems.forEach((item) => {
          if (item.children && item.children.length > 0) {
            newArr[item.route] = {
                route: item.route,
                name: item.name,
                icon: item.icon,
                title: item.title
              };
            setChildren(item.children);
          } else {
          if (item.route === 'dashboard-analytics') {
            this.isDashboardInApi = true;
          }
            newArr[item.route] = item;
          }
        });
          
        if (!this.isDashboardInApi) {
          this.dashboard.push(dashboardData[0]);
        }
        //newArr for implemention logic
        localStorage.setItem("rightsData", JSON.stringify(newArr));
        
        // Process menu items and add tags
        this.navMenuItems.forEach((item) => {
          if (item.title === 'Masters') {
            item.children.forEach((child) => {
              child.children = null;
            });
          }
          if (item.children && Array.isArray(item.children)) {
            item.tag = item.children.length;
            item.tagVariant = "light-success";
            item.children.forEach((child) => {
              if (child.children && Array.isArray(child.children) && child.children.length > 0) {
                child.tag = child.children.length;
                child.tagVariant = "light-info";
              }
            });
          }
        });
        
        // Remove children from specific menu items if they exist
        // console.log(this.navMenuItems, "navMenuItems");
        // if (this.navMenuItems[3] && this.navMenuItems[3].children) {
        //   if (this.navMenuItems[3].children[0]?.children) {
        //     this.navMenuItems[3].children[0].children = null;
        //   }
        //   if (this.navMenuItems[3].children[1]?.children) {
        //     this.navMenuItems[3].children[1].children = null;
        //   }
        //   if (this.navMenuItems[3].children[2]?.children) {
        //     this.navMenuItems[3].children[2].children = null;
        //   }
        // }
      })
      .catch((error) => console.log(error, "error"));
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props);

    const { skin } = useAppConfig();

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false);

    provide("isMouseHovered", isMouseHovered);

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    const collapseTogglerIconFeather = computed(() =>
      collapseTogglerIcon.value === "unpinned" ? "CircleIcon" : "DiscIcon"
    );

    // App Name
    const { appName, appLogoImage } = $themeConfig.app;

    return {
      // navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
    };
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
